export const ROTA_ACOMPANHAMENTO_MENSAL = "/perfilPessoal/acompanhamentoMensal";

export function validarRedirecionamentoCampanha(store, routeTo) {
  const rotaAtual = routeTo.fullPath;
  const pendente = Boolean(store.state.acompanhamentoMensal?.temPendencia);

  if (pendente && rotaAtual !== ROTA_ACOMPANHAMENTO_MENSAL) {
    return ROTA_ACOMPANHAMENTO_MENSAL;
  }

  return null;
}
